import Vue from 'vue'
import Router from 'vue-router';
import { getToken } from "@/utils/libs.js"
import { setTitle } from "@/utils/curren.js"
import { getStore } from "@/utils/store.js"
import { getUserInfo } from "@/api/system"
import store from '@/store'

import { Loading } from "element-ui"


// Progress 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//登录页面
import config from "@/config"
const { loginName, homeName } = config
Vue.use(Router);


const files = require.context('./modules', false, /\.js$/)
const modules = []

files.keys().forEach(key => {

	if (key === './index.js') return;
	if (key === './_import_production.js') return;
	if (key === './_import_development.js') return;

	modules.push(files(key).default);
});

const router = new Router({
	routes: [
		...modules,
	],

	mode: 'history'
});

router.beforeEach(async (to, form, next) => {
	NProgress.start();
	let token = getToken();
	let lock = getStore({ name: "isLock" }) || false
	//判断是否登录 且是否为登录页面
	if(!token && to.name!==loginName){
		next({name:loginName})
	} else if(!token && to.name == loginName){
		next();
	}else  if(lock && to.name !=="lock"){
		next({name:"lock"})
	}else if(lock && to.name=="lock"){
		next();
	}else if(!lock && to.name=="lock"){
		let result = await store.dispatch("handleUserInfo")
		next({name:homeName})
	}else if(to.name==homeName){
		let result = await store.dispatch("handleUserInfo")
		next();
	}else if(to.matched.length==0 && to.name!="404"){
		let result = await store.dispatch("handleUserInfo")
		next({name:"404"});
	}else if(to.matched.length==0 && to.name=="404"){
		let result = await store.dispatch("handleUserInfo")
		next();
	}else if (!store.state.user.userInfo.menu || store.state.user.userInfo.menu.length === 0){
		let result = await store.dispatch("handleUserInfo")
		if(to.name==""){
			next({name:homeName})
		}else if(store.state.user.userInfo.admin_id==1){
			next()
		}else if(store.state.user.userInfo.menu.indexOf(to.name)>=0){
			next();
		} else if(to.name=="404"){
			next();
		} else if(to.name=="401"){
			next()
		}else{
			next({name:"401"})
		}
	}else if(store.state.user.userInfo.admin_id==1){
		next()
	}else if(store.state.user.userInfo.menu.indexOf(to.name)>=0){
		next();
	} else if(to.name=="404"){
		next();
	}else if(to.name=="401"){
		next()
	}else{
		next({name:"401"})
	}
})

router.afterEach(to => {
	setTitle(to)
	NProgress.done();
	window.scrollTo(0, 0)
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js